import useFetch from 'utils/hooks/useFetch'
import { ApiCheckInBooking, ApiCompleteBooking, ApiDeleteBooking, ApiGetAvailableRoomList, ApiGetBooking, ApiGetBookingList, ApiInsertBooking, ApiReactiveBooking, ApiUpdateBooking } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function BookingService() {
    const { showFail } = useModal()

    const { fetch: apiCheckInBooking } = useFetch(ApiCheckInBooking)
    const { fetch: apiCompleteBooking } = useFetch(ApiCompleteBooking)
    const { fetch: apiGetBookingList } = useFetch(ApiGetBookingList)
    const { fetch: apiDeleteBooking } = useFetch(ApiDeleteBooking)
    const { fetch: apiInsertBooking } = useFetch(ApiInsertBooking)
    const { fetch: apiUpdateBooking } = useFetch(ApiUpdateBooking)
    const { fetch: apiGetBookingById } = useFetch(ApiGetBooking)
    const { fetch: apiReactiveBooking } = useFetch(ApiReactiveBooking)
    const { fetch: apiGetAvailableRoomList } = useFetch(ApiGetAvailableRoomList)

    const fetchCheckInBooking = async (bookingId) => {
        const res = await apiCheckInBooking({
            data: {
                bookingId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCompleteBooking = async (bookingId) => {
        const res = await apiCompleteBooking({
            data: {
                bookingId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchBookingList = async (tenantName, roomNumber, bookingStatus, bookingType, status, pageSize, pageIndex) => {
        const res = await apiGetBookingList({
            data: {
                tenantName,
                roomNumber,
                bookingStatus,
                bookingType,
                status,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteBooking = async (bookingId, status) => {
        const res = await apiDeleteBooking({
            data: {
                bookingId,
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchInsertBooking = async (tenantId, bookingDate, checkInDate, checkOutDate, roomNumberId, bookingStatus, bookingType, remark) => {
        const res = await apiInsertBooking({
            data: {
                tenantId,
                bookingDate,
                checkInDate,
                checkOutDate,
                roomNumberId,
                bookingStatus,
                bookingType,
                remark
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateBooking = async (bookingId, tenantId, bookingDate, checkInDate, checkOutDate, roomNumberId, bookingStatus, bookingType, remark) => {
        const res = await apiUpdateBooking({
            data: {
                bookingId,
                tenantId,
                bookingDate,
                checkInDate,
                checkOutDate,
                roomNumberId,
                bookingStatus,
                bookingType,
                remark
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchBookingById = async (bookingId) => {
        const res = await apiGetBookingById({
            data: {
                bookingId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchReactiveBooking = async (bookingId) => {
        const res = await apiReactiveBooking({
            data: {
                bookingId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchAvailableRoomList = async (checkInDate) => {
        const res = await apiGetAvailableRoomList({
            data: {
                checkInDate
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchCheckInBooking,
        fetchCompleteBooking,
        fetchBookingList,
        fetchDeleteBooking,
        fetchInsertBooking,
        fetchUpdateBooking,
        fetchBookingById,
        fetchReactiveBooking,
        fetchAvailableRoomList
    }
}